
<template>
  <div>
    <h2
      id="customer-admin-usersheader"
    >
      <router-link :to="{ name: 'customer-admin-groups' }">
        {{ org.name }}
      </router-link>
      | {{ group ? group.name : '' }}

      <span
        v-if="group && group.groupId !== '00000000-0000-4000-0000-000000000000'"
        style="font-size: 12pt;"
      >
        [
        <router-link
          :to="{ name: 'customer-admin-groups-groupId', params: { groupId: group.groupId } }"
        >
          Edit Group
        </router-link>
        ]
      </span>
    </h2>

    <div class="deactivate-link">
      <button
        class="btn btn-primary"
        @click.prevent="deactivateMembers"
      >
        Deactivate All {{ (isEdu) ? 'Students and Instructors' : 'Speakers and Coaches' }}
      </button>
    </div>

    <div
      v-if="users"
      class="table-responsive"
    >
      <table class="table table-striped table-bordered table-condensed">
        <caption
          v-if="isAdminList"
        >
          List of {{ group.name }}
        </caption>
        <caption
          v-if="!isAdminList"
        >
          List of {{ $router.currentRoute.query.active ? 'active' : 'all' }} {{ (isEdu) ? 'students' : 'speakers' }}
          in this {{ (isEdu) ? 'class' : 'group' }}
        </caption>
        <thead>
          <tr>
            <th
              width="20%"
              scope="col"
            >
              Name
            </th>
            <th
              width="20%"
              scope="col"
            >
              Email
            </th>
            <th
              v-if="!isAdminList"
              width="10%"
              scope="col"
            >
              Roles
            </th>
            <th
              v-if="!isAdminList"
              width="20%"
              scope="col"
            >
              Status for this {{ isEdu ? 'Class' : 'Group' }}
            </th>
            <th
              width="10%"
              scope="col"
            >
              Since
            </th>
            <th
              width="10%"
              scope="col"
            >
              Last login
            </th>
            <th
              width="10%"
              scope="col"
            >
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="user in users"
            v-if="user.membershipStatus === 'active' || !$router.currentRoute.query.active"
          >
            <td scope="row">
              {{ user.name }}
            </td>
            <td>{{ user.email }}</td>
            <td
              v-if="!isAdminList"
            >
              {{ user.roles.map(
                (r) => (r === 'manager') ? (isEdu) ? 'Instructor' : 'Coach' : (isEdu) ? 'Student' : 'Speaker')
                .join(', ') || ' ' }}
            </td>
            <td v-if="!isAdminList">
              <span :class="{ 'text-success': user.membershipStatus === 'active', 'text-danger': user.membershipStatus !== 'active' }">
                <svg
                  v-if="user.membershipStatus === 'active'"
                  class="icon-check"
                >
                  <use xlink:href="/static/svg-symbols.svg#icon-check" />
                </svg>
                <svg
                  v-else
                  class="icon-plus"
                >
                  <use xlink:href="/static/svg-symbols.svg#icon-plus" />
                </svg>
                <strong>{{ user.membershipStatus | startCase }}</strong>
              </span>
              <small v-if="org.billingModel != 1">
                -
                <span v-if="user.membershipPerpetual">
                  PERPETUAL
                </span>
                <span v-else>
                  <span v-if="user.membershipExpires">
                    <span v-if="user.membershipStatus === 'active'">
                      expires {{ user.membershipExpires | dateShort }}
                    </span>
                    <span v-else>
                      expired {{ user.membershipExpires | dateShort }}
                    </span>
                  </span>
                  <span v-else>
                    never activated
                  </span>
                </span>
              </small>
              <small v-else>
                <span v-if="user.membershipStatus !== 'active'">
                  expired {{ user.membershipExpires | dateShort }}
                </span>
              </small>
            </td>
            <td>{{ user.membershipStartDate | dateShort }}</td>
            <td>{{ user.lastLoginDate | dateShort }}</td>
            <td>
              <router-link
                :to="{ name: 'customer-admin-users-userId-groupId', params: { userId: user.userId, groupId: group.groupId } }"
              >
                Roles
              </router-link>
            </td>
          </tr>
          <tr v-if="!userCount">
            <td colspan="7">
              <h2 class="text-center">
                No users
              </h2>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .icon-check {
    fill: #04D97E !important;
    position: relative;
    top: 2px;
    height: 16px; width: 16px;
  }
  .icon-plus {
    transform: rotate(45deg);
    fill: #D3382F !important;
    position: relative;
    top: 2px;
    height: 16px; width: 16px;
  }
  .deactivate-link {
    margin: 4px 0 15px 4px;
    text-align: right;
  }
</style>

<script>
import groups from '../../services/groups';

export default {
  props: {
    org: {
      type: Object,
      required: true
    },
    group: {
      //type: Object,
      //required: true
    },
    users: {
      //type: Array,
      required: true
    },
    isEdu: {
      type: Boolean,
      default: false
    },
    groups: {
      type: Array,
      required: true
    },
    groupIdsToNames: {},
  },
  data() {
    return { };
  },
  computed: {
    isAdminList: {
      cache: false,
      get() {
        return (this.group && this.group.groupId && this.group.groupId === '00000000-0000-4000-0000-000000000000');
      }
    },
    userCount: {
      cache: false,
      get() {
        return this._.size(this.users);
      }
    }
  },
  created() {
  },
  methods: {
    deactivateMembers() {
      if (!window.confirm('Are you sure you want to expire all the coaches and speakers in this group?')) return;

      groups.deactivateMembers(this.group.groupId).then(() => {
        this.$store.dispatch('listGroupMembers', true).then(() => {
          this.$router.push({ name: 'customer-admin-groups' });
          window.setTimeout(() => {
            this.$store.dispatch('notify', {
              type: 'success',
              subject: 'Group Members Deactivated',
              text: 'All the coaches and speakers in this group have been deactivated.'
            });
          }, 500);
        });
      });
    },
  }
};
</script>
